// @import dependencies
import React, {useState, useEffect, useMemo} from 'react'
import { useForm } from 'react-hook-form'
import { useTranslation } from 'react-i18next'
import {Link} from 'react-router-dom'
// @end

// @import hooks
// @end

// @import components
import ReactSelectComponent from 'app_components/commons/reactSelect'
import PasswordRecoveryModule from 'app_components/modules/passwordRecovery'
// @end

// @INFO Import services
import {routingService} from 'app_services/routingService'
import CompanyService from 'app_services/campus/company/companyService'
// @end

// @import types
import { IUserHttpResponse } from 'app_types/userTypes'
import TextComponent from 'app_components/commons/TextComponent/TextComponent'
import FormTextField from 'app_components/commons/FormTextField/FormTextField'
import { FormControlLabel, MenuItem, Radio } from '@material-ui/core'
import { IoMdRadioButtonOff, IoMdRadioButtonOn } from 'react-icons/io'
import ButtonComponent from 'app_components/commons/Button/ButtonComponent'
import FormSelect from 'app_components/commons/FormSelect/FormSelect'
import AuthService from 'app_services/secure/auth/authService'
import RegisterWrapperCard from 'app_components/screens/register/components/RegisterWrapperCard/RegisterWrapperCard'
import Login2FAForm from './Login2FAForm/Login2FAForm'
// @end

// @ADD Component types
interface ILoginModuleLayoutProps {
  company?: any
  onSubmit: (credentials: any) => any,
  onCompanySelected?: any
  onHandlePasswordRecover: (userData: IUserHttpResponse) => void
  hideIcons?: boolean;
  hidePersonBusiness?: boolean;
  hideForgotPassword?: boolean;
  hideReturnToCampus?: boolean;
  hideGoToRegister?: boolean;
  text?: string;
  history?: any;
  loading?: boolean;
  shouldValidate2FA: boolean
  registerRedirect?: string
  handleSubmit2FA: (code: string) => void
}

const LoginModuleLayout: React.FC<ILoginModuleLayoutProps> = (props) => {

  const companyService: CompanyService = new CompanyService()
  const authService = useMemo(() => new AuthService(), [])

  const [logoImage, setlogoImage] = useState<any>(require('app_assets/images/logos/logo.png'))
  const campusLogo = require('app_assets/images/logos/logo_campus.png')
  const isotipo = require('app_assets/images/logos/isotipo.png')

  const { t } = useTranslation()
  const [listOfCompanies, setListOfCompanies] = useState<Array<any>>([])
  const [componentStarted, setComponentStarted] = useState<string>('login')
  const [shouldSavePassword, setShouldSavePassword] = useState<boolean>(false)

  const formHook = useForm({ defaultValues: authService.getCredentials() })
  const loginType = formHook.watch('loginType')
  const company = formHook.watch('company')

  const handleClickContinueCompanyLogin = () => {
    if (company && props.onCompanySelected) {
      props.onCompanySelected(company)
    }
  }

  const onSubmit = (credentials: any) => {
    if (loginType === 'business') {
      handleClickContinueCompanyLogin()
    } else {
      props.onSubmit(credentials)
    }

    if (shouldSavePassword) {
      authService.saveCredentials(credentials.username, credentials.password)
    }
  }

  useEffect(() => {
    getCompanies()
  }, [])

  useEffect(() => {
    if (props.company && props.company.logo) {
      setlogoImage(props.company.logo)
    }
  }, [props.company])

  useEffect(() => {
    if (authService.getCredentials()) {
      setShouldSavePassword(true)
    }
  }, [authService])

  useEffect(() => {
    if (props.shouldValidate2FA) {
      setComponentStarted('2fa-form')
    }
  }, [props.shouldValidate2FA])

  const getCompanies = async () => {
    let companies: Array<any> = []
    const companiesResponse = await companyService.fetchCompanies()
    if (companiesResponse) {
      companiesResponse.companies.map((type: any) => {
        companies.push({ value: type._id, label: type.name })
      })
    }
    setListOfCompanies(companies)
  }

  const handlePasswordRecoveryGoBack = () => {
    setComponentStarted('login')
  }

  return (
    <div className='login-module--layout'>
      {componentStarted === 'login' && (
        <div className="login_module-component" style={{backgroundImage: `url('${isotipo}')`}}>
          {!props.hideIcons ?
            <Link className='' to={routingService.getPublicPath()}>
              <div className='login-module--icons'>
                <img src={logoImage} alt="Logo icon" />
                <img src={campusLogo} alt="Campus icon" />
              </div>
            </Link>
          :null}

          {props.text ?
            <TextComponent
              type='subtitle'
              style={{textAlign: 'center'}}
            >
              {props.text}
            </TextComponent>
          :null}

          <TextComponent
            width='100%'
            type="subtitle"
            textAlign='center'
            color="#7C878E"
            marginBottom='14px'
            fontWeight={500}
            marginTop={20}
          >
            Iniciar sesión
          </TextComponent>

          <div className="login-form">
            <form className='login-module--container-fields' onSubmit={formHook.handleSubmit(onSubmit)}>
              {!props.company && !props.hidePersonBusiness && (
                <FormSelect
                  control={formHook.control}
                  id='loginType'
                  label='Soy'
                  variant='outlined'
                  error={!!formHook.errors?.loginType}
                >
                  <MenuItem value="student">Estudiante</MenuItem>
                  <MenuItem value="business">Empresa</MenuItem>
                </FormSelect>
              )}
              {loginType === 'business' ? (
                <div className="login-module--select-company">
                  <ReactSelectComponent
                    identifier='company'
                    options={listOfCompanies}
                    formHooks={formHook}
                    defaultValue={[]}
                    isMulti={false}
                    required={true}
                    placeholder='Seleccione su empresa'
                  />
                </div>
              ): formHook.unregister('company')}
              {(!loginType || loginType === 'student') && (
                <>
                  <FormTextField
                    control={formHook.control}
                    id='username'
                    error={formHook.errors.username}
                    errorText='Este campo es requerido'
                    label="Usuario"
                    required
                  />
                  <FormTextField
                    control={formHook.control}
                    id='password'
                    error={formHook.errors.password}
                    errorText='Este campo es requerido'
                    label="Contraseña"
                    type='password'
                    required
                  />
                  <div className='login-module--password-actions'>
                    <FormControlLabel
                      value="save-password"
                      control={(
                        <Radio
                          icon={<IoMdRadioButtonOff />}
                          checkedIcon={<IoMdRadioButtonOn color='var(--primary)' />}
                          checked={shouldSavePassword}
                          onClick={() => setShouldSavePassword(!shouldSavePassword)}
                        />
                      )}
                      label="Recordar"
                    />
                    {!props.hideForgotPassword && (
                      <div className='login-module--forgot-password'>
                        <TextComponent onClick={() => setComponentStarted('password-recovery')} textDecoration='underline' fontWeight={300} cursor='pointer'>
                          {t('modules.login.forgot_password')}
                        </TextComponent>
                      </div>
                    )}
                  </div>
                </>
              )}

              <ButtonComponent
                textTransform='initial'
                marginTop='auto'
                variant='secondary'
                width="100%"
                paddingTop={10}
                paddingBottom={10}
                fontSize={18}
                type="submit"
                loading={props.loading}
              >
                {loginType === 'business' ? 'Continuar' : 'Ingresar'}
              </ButtonComponent>

              {(!props.hideGoToRegister || !props.hideReturnToCampus) && (
                <div className="login-forgot-pass">
                  {!props.hideReturnToCampus && (
                    <Link className='' to={routingService.getPublicPath('')}>
                      <TextComponent fontWeight={300} textDecoration='underline'>Volver al campus</TextComponent>
                    </Link>
                  )}
                  {!props.hideGoToRegister && (
                    <div className='login-module--register-text'>
                      <TextComponent>
                        Aun no tienes cuenta
                      </TextComponent>
                      <Link to={`/register${props.registerRedirect?.length ? `?redirect=${props.registerRedirect}` : ''}`}>
                        <TextComponent fontSize='1.2rem' textDecoration='underline'>Regístrate</TextComponent>
                      </Link>
                    </div>
                  )}
                </div>
              )}

            </form>

          </div>

        </div>
      )}
      {componentStarted === 'password-recovery' && (
        <RegisterWrapperCard title="Recuperar contraseña">
          <PasswordRecoveryModule
            onGoBack={handlePasswordRecoveryGoBack}
            onHandlePasswordRecover={props.onHandlePasswordRecover}
          />
        </RegisterWrapperCard>
      )}
      {componentStarted === '2fa-form' && (
        <Login2FAForm
          loading={props.loading}
          onGoBack={handlePasswordRecoveryGoBack}
          onSubmit={props.handleSubmit2FA}
        />
      )}
    </div>
  )
}

export default LoginModuleLayout
